import "../epicLeaderboard/epicLeaderboard.css";

// Same look as the epic leaderboard tables (epic-lb-table).
function Table2(props) {
  const { headers, desktopHeaderSizes = [], data } = props;
  return (
    <div className="epic-lb-table-scroll">
      <table className="epic-lb-table">
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th className={desktopHeaderSizes[index] || undefined} key={index}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index + row[0]}>
              {row.map((rowItem, i) => (
                <td key={`${index}-${i}`}>{rowItem}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Table2;
